import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5DataUploadTable } from "./table";
import { A5DataUploadEdit } from "./edit";

export default function A5DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5DataUploadEdit />} />
      <Route index element={<A5DataUploadTable />} />
    </Routes>
  );
}
